const translations = Object.freeze({
        english: {
            earn: "Earn",
            submit: "Submit",
            confirm: "Click again to submit empty answer",
            confirmMobile: "Tap again to submit empty answer",
            skip: "Skip",
            hint: "Hint",
            continue: "Continue",
            createdBy: "Created by",
            rate: "Rate our presentation",
            watchAgain: "Watch Again",
            true: "True",
            false: "False",
            yes: "Yes",
            no: "No",
            correct: "Correct",
            incorrect: "Incorrect",
            agree: "Agree",
            disagree: "Disagree",
            typeTheNamePH: "Type the name...",
            find: "Find"
        },
        hindi: {
            earn: "अंक प्राप्त किए",
            submit: "सब्मिट करें",
            confirm: "Click again to submit empty answer",
            confirmMobile: "Tap again to submit empty answer",
            skip: "स्किप करें",
            hint: "हिंट लें",
            continue: "जारी रखें",
            createdBy: "प्रस्तुत कर्ता प्रस्तुत",
            rate: "हमारी प्रस्तुति को रेट करें ",
            watchAgain: "फिर से देखें",
            true: "सही",
            false: "गलत",
            yes: "हाँ",
            no: "नहीं",
            correct: "सही",
            incorrect: "गलत",
            agree: "सहमत",
            disagree: "असहमत",
            typeTheNamePH: "यहाँ नाम टाइप करें...",
            find: "ढूँढें"
        }
    }
);

export default translations;
export {translations};